import { render, staticRenderFns } from "./expend.vue?vue&type=template&id=6a81b1bf&scoped=true&"
import script from "./expend.vue?vue&type=script&lang=js&"
export * from "./expend.vue?vue&type=script&lang=js&"
import style0 from "./expend.vue?vue&type=style&index=0&id=6a81b1bf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a81b1bf",
  null
  
)

export default component.exports